import React from 'react';
import { SCaptionsButton } from './styled';

interface IProps {
  enabled: boolean;
  onToggle: () => void;
}

const CaptionsToggle: React.FC<IProps> = ({ enabled, onToggle }) => (
  <SCaptionsButton
    $active={enabled}
    onClick={onToggle}
    aria-label={enabled ? 'Disable captions' : 'Enable captions'}
    aria-pressed={enabled}
  >
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" />
    </svg>
  </SCaptionsButton>
);

export default CaptionsToggle;
